import { render, staticRenderFns } from "./standardInfo.vue?vue&type=template&id=d86623a0&scoped=true&"
import script from "./standardInfo.vue?vue&type=script&lang=js&"
export * from "./standardInfo.vue?vue&type=script&lang=js&"
import style0 from "./standardInfo.vue?vue&type=style&index=0&id=d86623a0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d86623a0",
  null
  
)

export default component.exports